exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".borderR5:not(.nb){padding-top:10px!important}.borderR5.fleet-item.mt-3{max-height:calc(100vh - 250px);overflow-y:scroll}a:focus,a:hover{color:#2f87e2}.my-1{margin-right:10px;margin-left:10px}@media (max-width:768px){ul.fleet-list{flex-flow:column wrap!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/css-loader?minimize!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/style-rewriter.js?id=data-v-758d579f!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=styles&index=0!./vue/fleet/App.vue
// module id = 121
// module chunks = 3